import { FormGroup } from '@angular/forms';

import { disposableEmail } from 'src/assets/lists/disposable-email';
import { environment } from 'src/environments/environment.local';

export function DisposableEmail(controlName: string) {
    return (formGroup: FormGroup) => {
        const emailControl = formGroup.controls[controlName];
        if (emailControl.errors && !emailControl.errors.mustMatch) {
            // return if another validator has already found an error on the emailControl
            return;
        }
        if (environment.production && emailControl && disposableEmail.some(item => emailControl.value.includes(item))) {
            emailControl.setErrors({ disposable: true });
        } else {
            emailControl.setErrors(null);
        }
    };
}
